import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useLayoutEffect, useRef } from "react";

gsap.registerPlugin(ScrollTrigger);

export default function ShopHero() {
  const root = useRef<HTMLElement>(null);

  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: root.current,
          start: "top 80%",
          toggleActions: "play none none none",
        },
      });
      tl.fromTo(
        ".shop-hero-line",
        { scaleX: 0 },
        { scaleX: 1, duration: 1, ease: "power2.inOut" }
      ).fromTo(
        ".shop-hero-word",
        { y: 100, opacity: 0 },
        { y: 0, opacity: 1, duration: 1, stagger: 0.08, ease: "power3.out" },
        "-=0.8"
      );
    }, root);
    return () => ctx.revert();
  }, []);

  return (
    <section ref={root} className="bg-bone pt-32 md:pt-40 pb-8 md:pb-14 px-6 md:px-10">
      <div className="max-w-[1200px] mx-auto">
        {/* Massive headline */}
        <h1 className="font-display tracking-tightest leading-[0.85] text-ink">
          <span className="block overflow-hidden">
            <span className="shop-hero-word inline-block text-[clamp(3.5rem,12vw,9.5rem)] md:text-[clamp(4rem,11vw,9rem)]">
              The Collection
            </span>
          </span>
        </h1>

        {/* Thin divider */}
        <div className="shop-hero-line h-px bg-ink/15 origin-left mt-6 md:mt-8" />
      </div>
    </section>
  );
}